export function parseNumberLike(value) {
  if (value == null) return null;
  const n = typeof value === 'number' ? value : parseFloat(String(value).replace(',', '.'));
  return Number.isFinite(n) ? n : null;
}

// Compute effective services limit for an org, optionally applying Module_discount ranges
export function computeEffectiveLimit(org) {
  const base = parseNumberLike(org?.limite_servizi);
  return base == null ? null : base;
}
